export function getEncodedUrlPath(): string {
    return encodeURIComponent(
        location.pathname +
        location.hash +
        location.search
    );
}
